import { isDev } from './core/helper'


export const config = {
    site_url: isDev() ? 'http://localhost:3001' : 'https://blago.al19.ru',
    api_url: isDev() ? 'http://127.0.0.1:2828' : 'https://blago.al19.ru',
    header_token: 'x-ha-token',
}